import * as angular from 'angular';
import { NgModule, Injectable, bundle } from 'ng-metadata/core';

// Shared Styles
import './content-documents.scss';

// Shared Content Document Components ("Atoms")
import { ActionTriggerComponent } from './shared/action-trigger/action-trigger.component';
import { AuthorComponent } from './shared/author/author.component';
import { ContentDocumentPlaceholderComponent } from './shared/placeholder/content-document-placeholder.component';
import { FooterComponent } from './shared/footer/footer.component';
import { ImageComponent } from './shared/media/image.component';
import { KeywordsComponent } from './shared/keywords/keywords.component';
import { SourceAvatarComponent } from './shared/source-avatar/source-avatar.component';
import { TitleComponent } from './shared/title/title.component';
import { TrayComponent } from './shared/tray/tray.component';
import { TrayFooterComponent } from './shared/tray-footer/tray-footer.component';
import { TrayLoaderComponent } from './shared/tray-loader/tray-loader.component';
import { YoutubeVideoComponent } from './shared/media/youtube-video.component';

// Shared Pipes
import { LinkyHtmlPipe } from './shared/linky-html.pipe';
import { SanitizeInvalidHtmlPipe } from './shared/sanitize-invalid-html.pipe';
import { StripTagsPipe } from './shared/strip-tags.pipe';
import { TrustUrlPipe } from './shared/trust-url.pipe';

import { MediaContactDocumentModule } from './media-contact-document/media-contact-document.module';
import { MediaContentDocumentModule } from './media-document/media-document.module';
import { MediaSourceDocumentModule } from './media-source-document/media-source-document.module';

// Standard non ng-metadata module for components that can't be defined using ng-metadata
let ContentDocumentsNgModule = angular
    .module('mw.components.contentDocuments', ['ngMaterial'])
    .component(TrayFooterComponent.config.selector, TrayFooterComponent.config as any);

/**
 * @ngdoc module
 * @name mw.components.contentDocuments
 * @description
 *
 */
@NgModule({
    imports: [MediaContactDocumentModule, MediaContentDocumentModule, MediaSourceDocumentModule, ContentDocumentsNgModule.name],
    declarations: [
        ActionTriggerComponent,
        AuthorComponent,
        ContentDocumentPlaceholderComponent,
        FooterComponent,
        ImageComponent,
        KeywordsComponent,
        LinkyHtmlPipe,
        SanitizeInvalidHtmlPipe,
        SourceAvatarComponent,
        TitleComponent,
        StripTagsPipe,
        TrayComponent,
        TrayLoaderComponent,
        TrustUrlPipe,
        YoutubeVideoComponent
    ]
})
export class ContentDocumentsModule {}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/content-documents.module.ts